__webpack_require__.p = "/static/candidate-basic-search/";